import React from "react";

import { InputLabel, MenuItem, Select, FormControl } from "@material-ui/core";

export default function CustomSelect(props) {
	const { handleChange, value, data } = props;
	const { label, required, id, options } = data;

	if (options.length === 0) return null;
	return (
		<FormControl fullWidth required={required}>
			<InputLabel id={`${id}label`}>{label}</InputLabel>
			<Select labelId={`${id}label`} id={id} name={id} value={value} onChange={handleChange}>
				{options.map((option) => (
					<MenuItem key={option} value={option}>
						{option}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}
